import { Delete, Get, Post, Put, getAPIUrl } from "../../../services/apiMethod";
import { Categoryendpoint } from "./CategoryEndpoints";

export const getCategoryDetails = (param = "") => {
  const url = getAPIUrl(Categoryendpoint.getCategoryDetails, param);
  return Get(url);
};
export const addCategory = (data, param = "") => {
  const url = getAPIUrl(Categoryendpoint.addCategory, param);
  return Post(url, data);
};
export const addSubCategory = (data, param = "") => {
  const url = getAPIUrl(Categoryendpoint.addSubCategory, param);
  return Post(url, data);
};
export const editCategory = (data, param = "") => {
  const url = getAPIUrl(Categoryendpoint.editCategory, param);
  return Put(url, data);
};
export const editSubCategory = (data, param = "") => {
  const url = getAPIUrl(Categoryendpoint.editSubCategory, param);
  return Put(url, data);
};
export const deleteCategory = (param = "") => {
  const url = getAPIUrl(Categoryendpoint.deleteCategory, param);
  return Delete(url, param);
};
export const deleteSubCategory = (param = "") => {
  const url = getAPIUrl(Categoryendpoint.deleteSubCategory, param);
  return Delete(url, param);
};

export const deleteSelectedCategory = (param = "") => {
  const url = getAPIUrl(Categoryendpoint.deleteSelectedCategory, param);
  return Delete(url, param);
};
